import React from 'react';

import Icon from '../Icon/Icon';

const ManualActivationIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g transform='translate(12.938 9.115)' fill='none' fillRule='evenodd'>
                <path
                    d='M38.088 45.713H6.933C2.1 45.713 0 43.345 0 39.882V14.723l38.088.002v30.988z'
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinejoin='round'
                />
                <path
                    d='M5.58 14.723v-3.84C5.58 4.872 10.452 0 16.462 0h5.303c6.01 0 10.882 4.872 10.882 10.882v3.841'
                    stroke='#34303D'
                    strokeWidth='2.5'
                />
                <circle fill='#00D1D2' cx='19.063' cy='30.385' r='10' />
                <path
                    d='M19.044 23.885c.124 0 .244.018.357.052a2.501 2.501 0 0 1 .893 4.654v7.427a1.25 1.25 0 0 1-2.493.127l-.007-.127v-7.449a2.499 2.499 0 0 1 .855-4.62 1.26 1.26 0 0 1 .395-.064z'
                    fill='#34303D'
                    fillRule='nonzero'
                />
            </g>
        </Icon>
    );
};

export default ManualActivationIcon;
